const processData = (item) => {
  const { id, snippet, player } = item;
  const { title, description, thumbnails } = snippet || {};

  return {
    id: `youtube-${id}`,
    title,
    description,
    imageUrl: thumbnails?.medium?.url || '',
    embedPlayer: adjustYoutubeUrl(player?.embedHtml) || '',
    type: 'youtube',
  };
};

export const parseData = (data) => {
  const items = data?.result?.items || [];

  const playlistIds = [];
  const playlistById = {};

  if (items) {
    items.map((item, index) => {
      const processedData = processData(item);
      const { id } = processedData;

      playlistIds.push(id);
      playlistById[id] = processedData;
    });
  }

  return { playlistById, playlistIds };
};

const adjustYoutubeUrl = (embedHtml) => {
  return embedHtml.replace(/src=["']([^"']+)["']/, (_, src) => {
    const url = new URL(src.replace('http://', 'https://'));

    url.searchParams.set('rel', '0');
    url.searchParams.set('modestbranding', '1');

    return `src="${url}"`;
  });
};
